import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'relements/build/esm/ui/accordion';
import Loader from 'relements/build/esm/decorators/loader';
import Button from 'relements/build/esm/ui/button';
import ButtonV2 from '@src/components/ButtonV2';

// Actions
import { createAlert } from 'actions/BotActions';

import connection from '@src/connection';
import {
  TEMPLATE_TYPES,
  SDK_LOADER_URL,
  AlertTypes,
} from '@src/constants/MogamboConstants';
import Icon from '@src/components/Icon';
import IconV2 from 'relements/build/esm/ui/icon';

import CategoryIcons from '@src/components/SubstoryNavigation/components/AddSkillsDrawer/icons';
import * as maps from './maps';

import './ViewTemplateDetailsModal.scss';

const ACCORDION_ITEM_KEY = {
  HOW_TO_USE: 'how-to-use',
  API: 'api',
  ENTITY: 'entity',
  NODE: 'node',
};

@Loader({})
@connection(maps.listenToStores, maps.getStateFromStores)
export default class ViewTemplateDetailsModal extends React.Component {
  constructor(props) {
    super(props);

    this.isSubstoryTemplate = false;
    this.isGeneralNodeTemplate = false;

    this.state = {
      activeAccordionItem: null,
    };
  }

  componentWillMount() {
    this.props.activateLoader();
    maps.fetchTemplateData(this.props.templateId, (error) => {
      this.props.deactivateLoader();
      if (error) {
        createAlert(`${error}`, undefined, AlertTypes.NEGATIVE);
      }
    });
  }

  componentWillUnmount() {
    setTimeout(() => {
      maps.updateTemplateData(null, {});
    }, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.templateData &&
      this.props.loaderActive &&
      this.props.templateId === nextProps.templateData.id
    ) {
      this.isSubstoryTemplate = [
        TEMPLATE_TYPES.SUBSTORY_TEMPLATE,
        TEMPLATE_TYPES.SUBSTORY_WITH_API_TEMPLATE,
      ].includes(nextProps.templateData.template_type);

      this.isGeneralNodeTemplate = [
        TEMPLATE_TYPES.BOT_GENERAL_TEMPLATE,
      ].includes(nextProps.templateData.template_type);

      this.props.deactivateLoader();

      setTimeout(() => {
        const smartSkillCategoryName = nextProps.templateData.tags[0];
        const componentData = {
          title: nextProps.templateData.name,
          subtitle: nextProps.isSmartSkill
            ? smartSkillCategoryName
            : 'About Template',
          hasSaveButton: true,
        };

        switch (nextProps.templateData.template_type) {
          case TEMPLATE_TYPES.BOT_GENERAL_TEMPLATE:
            if (this.props.metatags.domain.id) {
              componentData.onSave = this.addGeneralNodeTemplateToBot;
              componentData.saveButtonText = 'Use Template';
            }
            break;

          case TEMPLATE_TYPES.SUBSTORY_TEMPLATE:
          case TEMPLATE_TYPES.SUBSTORY_WITH_API_TEMPLATE:
            if (this.props.metatags.story.id) {
              componentData.onSave = this.addSubstoryTemplateToStory;
              componentData.saveButtonText = 'Use Template';
            }
            break;

          default:
            break;
        }

        maps.updateComponentModal(componentData);
      }, 0);
    }
  }

  onSave() {
    switch (this.props.templateData.template_type) {
      case TEMPLATE_TYPES.BOT_GENERAL_TEMPLATE:
        if (this.props.metatags.domain.id) {
          this.addGeneralNodeTemplateToBot();
        }
        break;

      case TEMPLATE_TYPES.SUBSTORY_TEMPLATE:
      case TEMPLATE_TYPES.SUBSTORY_WITH_API_TEMPLATE:
        if (this.props.metatags.story.id) {
          this.addSubstoryTemplateToStory();
        }
        break;

      default:
        break;
    }
  }

  render() {
    const { templateData } = this.props;

    const validCredentials =
      templateData.credentials &&
      templateData.credentials.business_id &&
      templateData.credentials.partner_client_id &&
      templateData.credentials.partner_api_key;

    return (
      <div
        className={`view-template-details ${
          this.props.isV2 ? 'smartskill-details' : ''
        }`}
      >
        <div
          className={`template-details-wrapper ${
            this.props.isV2 ? 'smartskill-details-wrapper' : ''
          }`}
        >
          <div className="template-details-scroll-wrapper">
            {this.renderTemplateTypeDetails()}
            {this.renderTemplatePurposeDetails()}
            <Accordion
              className={this.props.isV2 ? 'smartskill-accordion' : ''}
              useDragHandle
            >
              <Accordion.Item
                key={ACCORDION_ITEM_KEY.HOW_TO_USE}
                index={ACCORDION_ITEM_KEY.HOW_TO_USE}
                active={
                  this.state.activeAccordionItem ===
                  ACCORDION_ITEM_KEY.HOW_TO_USE
                }
                onChange={() =>
                  this.toggleAccordion(ACCORDION_ITEM_KEY.HOW_TO_USE)
                }
                renderHeader={({ ExpandIcon }) => (
                  <div className="template-details-item-header">
                    How To Use(s)
                    <ExpandIcon />
                  </div>
                )}
              >
                {this.props.isV2
                  ? this.renderTemplateUsageDetailsV2()
                  : this.renderTemplateUsageDetails()}
              </Accordion.Item>

              {this.isSubstoryTemplate && (
                <Accordion.Item
                  key={ACCORDION_ITEM_KEY.API}
                  index={ACCORDION_ITEM_KEY.API}
                  active={
                    this.state.activeAccordionItem === ACCORDION_ITEM_KEY.API
                  }
                  onChange={() => this.toggleAccordion(ACCORDION_ITEM_KEY.API)}
                  renderHeader={({ ExpandIcon }) => (
                    <div className="template-details-item-header">
                      API(s)
                      <ExpandIcon />
                    </div>
                  )}
                >
                  {this.props.isV2
                    ? this.renderTemplateAPIDetailsV2()
                    : this.renderTemplateAPIDetails()}
                </Accordion.Item>
              )}

              {this.isSubstoryTemplate && (
                <Accordion.Item
                  key={ACCORDION_ITEM_KEY.ENTITY}
                  index={ACCORDION_ITEM_KEY.ENTITY}
                  active={
                    this.state.activeAccordionItem === ACCORDION_ITEM_KEY.ENTITY
                  }
                  onChange={() =>
                    this.toggleAccordion(ACCORDION_ITEM_KEY.ENTITY)
                  }
                  renderHeader={({ ExpandIcon }) => (
                    <div className="template-details-item-header">
                      Entity(s)
                      <ExpandIcon />
                    </div>
                  )}
                >
                  {this.props.isV2
                    ? this.renderTemplateEntityDetailsV2()
                    : this.renderTemplateEntityDetails()}
                </Accordion.Item>
              )}

              {this.isGeneralNodeTemplate && (
                <Accordion.Item
                  key={ACCORDION_ITEM_KEY.NODE}
                  index={ACCORDION_ITEM_KEY.NODE}
                  active={
                    this.state.activeAccordionItem === ACCORDION_ITEM_KEY.NODE
                  }
                  onChange={() => this.toggleAccordion(ACCORDION_ITEM_KEY.NODE)}
                  renderHeader={({ ExpandIcon }) => (
                    <div className="template-details-item-header">
                      Sample Steps
                      <ExpandIcon />
                    </div>
                  )}
                >
                  {this.renderTemplateNodeList()}
                </Accordion.Item>
              )}
            </Accordion>
          </div>
          {this.props.isV2 && (
            <div className="template-details-footer">
              <ButtonV2 onClick={() => this.onSave()}>Add Smart Skill</ButtonV2>
            </div>
          )}
        </div>
        <div className="test-bot-wrapper">
          {validCredentials &&
            this.renderSDK(
              templateData.credentials.business_id,
              templateData.credentials.partner_client_id,
              templateData.credentials.partner_api_key,
              templateData.credentials.base_url
            )}
        </div>
      </div>
    );
  }

  renderTemplatePurposeDetails = () => {
    const { templateData } = this.props;

    return (
      <div className="template-details-container template-details-purpose">
        <div className="template-details-purpose-key template-details-strong">
          Purpose
        </div>
        <div className="template-details-purpose-value">
          <pre>{templateData.description}</pre>
        </div>
      </div>
    );
  };

  renderTemplateTypeDetails = () => {
    let templateTypeLabel = '';
    let templateTypeIcon = '';
    let templateTypeIconV2 = '';

    switch (this.props.templateData.template_type) {
      case TEMPLATE_TYPES.BOT_GENERAL_TEMPLATE:
        templateTypeLabel = 'General Nodes';
        templateTypeIcon = 'template_general';
        templateTypeIconV2 = CategoryIcons.globe;
        break;

      case TEMPLATE_TYPES.SUBSTORY_TEMPLATE:
        templateTypeLabel = `Skill ${
          this.props.isSmartSkill ? 'Smart Skill' : 'Template'
        }`;
        templateTypeIcon = 'template_substory';
        templateTypeIconV2 = CategoryIcons.node;
        break;

      case TEMPLATE_TYPES.SUBSTORY_WITH_API_TEMPLATE:
        templateTypeLabel = `Skill With API ${
          this.props.isSmartSkill ? 'Smart Skill' : 'Template'
        }`;
        templateTypeIcon = 'template_substory_api';
        templateTypeIconV2 = CategoryIcons.nodeIndicator;
        break;

      default:
        break;
    }

    return (
      <div className="template-details-container template-details-type">
        {this.props.isV2 ? (
          <IconV2 src={templateTypeIconV2} size={IconV2.SIZES.BIG} />
        ) : (
          <Icon iconType={templateTypeIcon} />
        )}
        <div>{this.props.isSmartSkill ? 'Smart Skill' : 'Template'} Type:</div>
        <div>{templateTypeLabel}</div>
      </div>
    );
  };

  renderTemplateAPIDetailsV2 = () => {
    const apiDetails = this.props.templateData.details.api || {};
    const nodeList = Object.keys(apiDetails).filter((node) => {
      return Boolean(apiDetails[node]);
    });
    return (
      <div className="template-details-usage">
        {nodeList.length === 0 && (
          <div className="template-details-empty">
            No API Integrations are needed!
          </div>
        )}
        {nodeList.length > 0 && (
          <ol className="smartskill-details-list">
            {nodeList.map((node, index) => (
              <li key={`api${index}`}>
                <p>
                  <span className="text-bold">{node}</span>
                </p>
                <p>{apiDetails[node]}</p>
              </li>
            ))}
          </ol>
        )}
      </div>
    );
  };

  renderTemplateAPIDetails = () => {
    const apiDetails = this.props.templateData.details.api || {};
    const nodeList = Object.keys(apiDetails).filter((node) => {
      return Boolean(apiDetails[node]);
    });

    return (
      <div className="template-details-usage">
        {nodeList.length === 0 && (
          <div className="template-details-empty">
            No API Integrations are needed!
          </div>
        )}
        {nodeList.length > 0 && (
          <ol className="template-details-list">
            {nodeList.map((node, index) => {
              return (
                <li key={index} className="template-details-list-item">
                  <div className="template-details-list-item-row template-details-strong">
                    <div className="template-details-list-item-key">
                      Location
                    </div>
                    <div className="template-details-list-item-value">
                      {node}
                    </div>
                  </div>
                  <div className="template-details-list-item-row">
                    <div className="template-details-list-item-key">
                      Purpose
                    </div>
                    <div className="template-details-list-item-value">
                      {apiDetails[node]}
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        )}
      </div>
    );
  };

  renderTemplateEntityDetailsV2 = () => {
    const entityMap = {};
    this.props.templateData.entity_list.forEach((entity) => {
      entityMap[entity.name] = entity;
    });
    const entityDetails = this.props.templateData.details.entity || {};
    const entityList = Object.keys(entityDetails).filter((entity) => {
      return Boolean(entityDetails[entity]);
    });
    return (
      <div className="template-details-usage">
        {entityList.length === 0 && (
          <div className="template-details-empty">No Entities are needed!</div>
        )}
        {entityList.length > 0 && (
          <ol className="smartskill-details-list">
            {entityList.map((entity, index) => (
              <li key={`entity${index}`}>
                <p>
                  <span className="text-bold">{entity}</span> (Entity Type:{' '}
                  {entityMap[entity].type})
                </p>
                <p>{entityDetails[entity]}</p>
              </li>
            ))}
          </ol>
        )}
      </div>
    );
  };

  renderTemplateEntityDetails = () => {
    const entityMap = {};
    this.props.templateData.entity_list.forEach((entity) => {
      entityMap[entity.name] = entity;
    });
    const entityDetails = this.props.templateData.details.entity || {};
    const entityList = Object.keys(entityDetails).filter((entity) => {
      return Boolean(entityDetails[entity]);
    });

    return (
      <div className="template-details-usage">
        {entityList.length === 0 && (
          <div className="template-details-empty">No Entities are needed!</div>
        )}
        {entityList.length > 0 && (
          <ol className="template-details-list">
            {entityList.map((entity, index) => {
              return (
                <li key={index} className="template-details-list-item">
                  <div className="template-details-list-item-row template-details-strong">
                    <div className="template-details-list-item-key">
                      Entity Name
                    </div>
                    <div className="template-details-list-item-value">
                      {entity}
                      <span className="entity-type-label">
                        {' '}
                        (Entity Type: {entityMap[entity].type})
                      </span>
                    </div>
                  </div>
                  <div className="template-details-list-item-row">
                    <div className="template-details-list-item-key">
                      Purpose
                    </div>
                    <div className="template-details-list-item-value">
                      {entityDetails[entity]}
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        )}
      </div>
    );
  };

  renderTemplateNodeList = () => {
    return <div className="template-details-usage">Steps on Template</div>;
  };

  renderTemplateUsageDetails = () => {
    const { details = {} } = this.props.templateData;

    return (
      <div className="template-details-usage">
        <pre>{details.how_to_use}</pre>
      </div>
    );
  };

  renderTemplateUsageDetailsV2 = () => {
    const { details = {} } = this.props.templateData;
    const details_list = details.how_to_use
      ? details.how_to_use.split('\n')
      : [];
    return (
      <div className="template-details-usage">
        {details_list.length === 0 && (
          <div className="template-details-empty">Not available</div>
        )}
        {details_list.length > 0 && (
          <ol className="smartskill-details-list">
            {details_list.map((detail, index) => (
              <li key={`how_to_use_${index}`}>
                <p>{detail}</p>
              </li>
            ))}
          </ol>
        )}
      </div>
    );
  };

  renderSDK = (businessId, clientId, baseURL, apiKey) => {
    return (
      <iframe
        title="template-sdk"
        className="template-iframe"
        ref={(iframe) => {
          if (!this._iframe) {
            this._iframe = iframe;
            this._loadIframeContents(businessId, clientId, baseURL, apiKey);
          }
        }}
      />
    );
  };

  toggleAccordion = (itemKey) => {
    const activeAccordionItem =
      this.state.activeAccordionItem === itemKey ? null : itemKey;
    this.setState({
      activeAccordionItem,
    });
  };

  addGeneralNodeTemplateToBot = () => {
    this.props.activateLoader();
    maps.addGeneralNodeTemplateToBot(
      this.props.templateData,
      this.props.metatags
    );
  };

  addSubstoryTemplateToStory = () => {
    // Calculate a valid substory name
    let dstSubStoryName = JSON.parse(
      JSON.stringify(this.props.templateData.substory_name)
    );
    const currentSubstoryList = this.props.subStories.map(
      (subStory) => subStory.title
    );
    let count = 0;
    if (Array.isArray(dstSubStoryName)) {
      dstSubStoryName.map((dstSubStory, index) => {
        count = 0;
        currentSubstoryList.forEach((subStoryName) => {
          if (subStoryName.startsWith(dstSubStory)) {
            count += 1;
          }
        });
        if (count > 0) {
          dstSubStoryName[index] = `${dstSubStory} V${count}`;
        }
      });
    } else {
      currentSubstoryList.forEach((subStoryName) => {
        if (subStoryName.startsWith(dstSubStoryName)) {
          count += 1;
        }
      });
      if (count > 0) {
        dstSubStoryName = `${dstSubStoryName} V${count}`;
      }
    }

    this.props.templateData.isSmartSkill = this.props.isSmartSkill;

    this.props.activateLoader();
    maps.addTemplateToStory(
      this.props.templateData,
      this.props.metatags,
      dstSubStoryName,
      this.props.onUseTemplate && this.props.onUseTemplate
    );
  };

  _loadIframeContents = (businessId, clientId, apiKey, baseURL) => {
    const frame =
      this._iframe.contentWindow ||
      this._iframe.contentDocument.document ||
      this._iframe.contentDocument;
    frame.document.open();
    frame.document.write(`
            <html>
                <head>
                    <style>
                        iframe {
                            width: 100%;
                            height: 100%;
                        }
                        body {
                            margin: 0;
                        }
                    </style>
                </head>
                <body>
                    <script>
                        var haptikInitSettings = {
                          'business-id': ${businessId},
                          'client-id': '${clientId}',
                          'api-key': '${apiKey}',
                          'base-url': '${baseURL}',
                          'mode': 'mogambo',
                          'signup-type': 'guest',
                          'ignore-history': true
                        };
                    </script>
                    <script
                        onload="setTimeout(function(){HaptikSDK.expandWidget(); HaptikSDK.show()}, 5000)"
                        type="text/javascript"
                        charset="UTF-8"
                        src="${SDK_LOADER_URL}"
                    ></script>
                </body>
        `);
    frame.document.close();
  };
}

ViewTemplateDetailsModal.propTypes = {
  templateId: PropTypes.string.isRequired,
  templateData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    details: PropTypes.object,
    domain_id: PropTypes.string,
    how_to_use: PropTypes.string,
    description: PropTypes.string,
    template_type: PropTypes.number,
    substory_name: PropTypes.string,
    entity_list: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.string,
      })
    ),
  }),
  activateLoader: PropTypes.func,
  deactivateLoader: PropTypes.func,
  loaderActive: PropTypes.bool,
  metatags: PropTypes.shape({
    domain: PropTypes.object,
    story: PropTypes.object,
    subStory: PropTypes.object,
    step: PropTypes.object,
  }),
  subStories: PropTypes.arrayOf(PropTypes.object),
};
